import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  error: null,
  isFetching: false,
  content: {},
}

const reducers = {
  fetchingContent: (state, { payload }) => {
    const { contentStateKey } = payload
    state.error = null
    state.isFetching = true
    if (!state.content[contentStateKey]) {
      state.content[contentStateKey] = {}
    }
  },

  fetchContentError: (state, { payload }) => {
    const { contentStateKey, error } = payload
    state.error = error
    state.isFetching = false
    if (state.content[contentStateKey]) {
      state.content[contentStateKey].error = error
    }
  },

  fetchContentSuccess: (state, { payload }) => {
    const { contentStateKey, data } = payload
    state.error = null
    state.isFetching = false
    state.content[contentStateKey] = { data }
  },

  clearErrors: state => {
    state.error = null
  },
}

const slice = createSlice({
  initialState,
  name: 'curriculumContent',
  reducers,
})

export const actions = slice.actions
export default slice.reducer
